<app-main-nav-bar></app-main-nav-bar>
<!--1-->
<div class="main">
  <div class="wrap">
    <div class="person elem" style="display: block;">
      <div class="row">
        <div class="col col-12">
          <div class="head">
            <h2>بیمه گذار</h2>
            <p style="padding: 0 10px 0 10px;">افرادی که می&zwnj;بایست تحت پوشش بیمه درمان سلامت قرار بگیرند</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col col-12">
          <div class="list" *ngIf="translatedList.length">
            <div *ngFor="let translated of translatedList" class="item" data-person="fyvb73c">
              <div class="row">
                <div class="col col-6"><h2 style="text-align: right">اطلاعات پایه بیمه گذار</h2></div>
                <div class="col col-6">
                  <div class="controll">
                    <button (click)="openDialog(translated.original)" class="btn4 btn-delete"
                             data-person="fyvb73c" style="margin-left: 19px; border:lightgray;border-radius: 100%;height: 27px;">
                      <i class="icon ico-trash-2-outline"></i></button>
                  </div>
                </div>
              </div>
              <div class="info">
                <div class="row">
                  <div class="col col-6"><i class="icon ico-calendar-outline"></i>
                    <span>تاریخ تولد</span></div>
                  <div class="col col-6"><i class="icon ico-umbrella-outline"></i>
                    <span>بیمه پایه</span></div>
                </div>
                <div class="row">
                  <div class="col col-6">
                    <span class="val-birth">{{ getjalaliDate(translated.birthday) }}</span></div>
                  <div class="col col-6">
                    <span class="val-insurance">{{ translated.insurance }}</span></div>
                </div>
              </div>
              <div class="info">
                <div class="row">
                  <div class="col col-6"><i class="icon ico-person-outline"></i> <span>جنسیت</span>
                  </div>
                  <div class="col col-6"><i class="icon ico-link-outline"></i> <span>رابطه</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col col-6"><span class="val-gender"
                                               data-val="male">{{ translated.gender }}</span></div>
                  <div class="col col-6"><span class="val-relation"
                                               data-val="me">{{ translated.relation }}</span>
                  </div>
                </div>
              </div>
              <div class="info">
                <div class="row">
                  <div class="col col-6"><i class="icon ico-options-2-outline"></i> <span>وزن</span>
                  </div>
                  <div class="col col-6"><i class="icon ico-options-outline"></i> <span>قد</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col col-6"><span class="val-weight">{{ translated.weight }}</span>
                  </div>
                  <div class="col col-6"><span class="val-height">{{ translated.height }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="!translatedList" class="null" style="display: none;">
            <i class="icon ico-person-outline"></i>
            <p>هنوز بیمه گذاری اضافه نکرده&zwnj;اید...</p>
          </div>
          <app-custom-button [Show]="true" [disabled]="false" (OnClick)="addNewSubRequest()"
                             [LabelText]="'افزودن بیمه گذار جدید'" [backUrl]="'/health/family/basic-information'"
                             [BackButton]="!subRequestList.length"></app-custom-button>
        </div>
      </div>
    </div>
    <br>
    <br>
    <div class="row">
      <div class="col-12">
        <app-custom-button [LabelText]="'ادامه روند صدور بیمه'" [Show]="!(!subRequestList.length)" [disabled]="!subRequestList.length"
                           (OnClick)="submit()" [backUrl]="'/health/family/basic-information'"
                           [BackButton]="true" [HideMainButton]="!subRequestList.length"></app-custom-button>
      </div>
    </div>
  </div>
</div>
